import React from "react";
import { Form, Select } from "antd";
import { connect } from "dva";
import { SecurePassAutoSend, SecurePassAutoSendMap } from "@/utils/enum";
import { formatPrice } from "@/utils/utils";
import { Validator } from "@/utils/validator";

const SecurePassDropdown = ({ securePassThreshold, label, name }) => (
  <Form.Item
    name={name}
    label={label}
    rules={[Validator.required("Please select a secure pass type")]}
    initialValue={SecurePassAutoSend.DEFAULT}
    normalize={value => {
      if (value === 0 || value === undefined || value === null) {
        return SecurePassAutoSend.DEFAULT;
      }
      return value;
    }}
  >
    <Select getPopupContainer={trigger => trigger.parentElement}>
      {Object.values(SecurePassAutoSend).map(type => (
        <Select.Option key={type} value={type}>
          {type === SecurePassAutoSend.DEFAULT
            ? `Use for High Value Vehicles (${formatPrice(securePassThreshold, "en-US", "USD", 0)})`
            : SecurePassAutoSendMap[type]}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);

export default connect(({ configs }) => ({
  securePassThreshold: configs.securePass.threshold,
}))(SecurePassDropdown);
